import { useEffect, useState } from "react";
import { useSearch } from "./useSearch";

export const useAddLabel = (arr = [], label = "") => {
  const [newArr, setNewArr] = useState(arr);
  const { setSnackbar } = useSearch();
  try {
    useEffect(() => {
      const data = arr.map((item) => {
        return {
          ...item,
          value: item.id,
          label: item[label],
        };
      });

      setNewArr(data);
      // eslint-disable-next-line
    }, [arr]);

    return newArr;
  } catch (error) {
    console.log(error);
    setSnackbar(error);
  }
};
